import React from 'react'
import WeiShopSetting from '@components/LocalMerchant/WeiShopSetting'
import ProductIntro from '@common/ProductIntro'
import { PRODUCT_MICRO_WEBSITE } from '@constant'

export default {
  path: 'weiShopSetting',
  indexRoute: {
    component: WeiShopSetting
  },
  stat: '服务市场/微官网',
  childRoutes: [
    {
      path: 'intro',
      components: props => (
        <ProductIntro {...props} id={PRODUCT_MICRO_WEBSITE} />
      )
    }
  ]
}
